import { Action } from "common/types/redux";

import {
  Assignment,
  specsMap,
  UnsupportedSpecTypeError
} from "seneca-common/features/assignments/state";
import { formatDateTimeString } from "seneca-common/utils/functions/time";

export type MakeAssignment<A> = (
  arg0?: Record<string, any> | null | undefined
) => A;

type AssignmentReducerOptions<A, R extends Record<string, any>> = {
  makeAssignment?: MakeAssignment<A>;
  receiveAssignment?: (arg0: A, arg1: R, arg2: MakeAssignment<A>) => A;
  receiveActionType: string;
};

export default function makeAssignmentReducer<
  A,
  R extends Record<string, any>
>({
  // @ts-ignore
  makeAssignment = (values?: any) =>
    new Assignment({
      ...values,
      startDate: formatDateTimeString(values.startDate),
      dueDate: formatDateTimeString(values.dueDate),
      assignmentCutoffDate: formatDateTimeString(values.assignmentCutoffDate)
    }),
  receiveAssignment = defaultReceiveAssignment,
  receiveActionType
}: AssignmentReducerOptions<A, R>) {
  return function assignmentReducer(
    state: A = makeAssignment(),
    action: Action<R>
  ): A {
    switch (action.type) {
      case receiveActionType:
        return receiveAssignment(state, action.payload!, makeAssignment);

      default:
        return state;
    }
  };
}

function defaultReceiveAssignment<A, R extends Record<string, any>>(
  state: A,
  received: R,
  makeAssignment: MakeAssignment<A>
): A {
  const { id, specType, spec } = received;

  if (!(specsMap as any)[specType] || !(specsMap as any)[specType].fromJS) {
    throw new UnsupportedSpecTypeError(id, specType);
  }

  const fromJS = (specsMap as any)[specType].fromJS;

  return makeAssignment({
    id,
    ...received,
    spec: new fromJS(spec)
  });
}
